export default "/images/vendor/flag-icons/flags/4x3/uy.svg?2515d7371de19a0642e6a1cb2c59ef6a";